import React, { useState, useEffect } from "react";
// import * as XLSX from 'xlsx';
import {
  GetByDates,
  Post,
  Patch,
  Donwload,
} from "../../api/reports/motivationMNG";

const MotivationMNG = ({ token, accessLevel }) => {
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [haveReport, setHaveReport] = useState(false);
  const [report, setReport] = useState({});
  const [modalMessage, setModalMessage] = useState("");
  const [workSpinner, setWorkSpinner] = useState(false);
  const [testTable, setTestTable] = useState(null);
  const [testDataTable, setTestDataTable] = useState({
    header: [],
    body: [],
  });

  const reportId = 2;
  const juniourMNGPremium = 20000;
  const MNGPremium = 20000;
  const seniourMNGPremium = 30000;

  const DefaultFields = [
    ["resultHI", "show_name", ""], //0
    ["premiumHI", "show_name 2", ""], //
    ["resultPOST", "show_name 2", ""], //2
    ["premiumPOST", "show_name 2", ""],
    ["resultPOSTMOSCOW", "show_name 2", ""], // 4
    ["premiumPOSTMOSCOW", "show_name 2", ""],
    ["resultTMT", "show_name 2", ""], // 6
    ["premiumTMT", "show_name 2", ""],
    // ["resultProduct", "show_name 2", ""], // 8
    // ["premiumProduct", "show_name 2", ""],
    // ["resultPlace", "show_name 2", ""], // 10
    // ["premiumPlace", "show_name 2", ""],
    ["resultTO", "show_name 2", ""], // 12
    ["premiumTO", "show_name 2", ""],
    ["premiumJuniourNMG", "show_name 2", ""], //14
    ["premiumProductMNG", "show_name 2", ""],
    ["premiumPlaceMNG", "show_name 2", ""], //16
    ["premiumSeniorMNG", "show_name 2", ""],
    // ["resultProductList", "show_name 2", ""], //18  из-за того ,что премия Products за чек-лист была добавлена после первого запуска
    // Пришлось её так странно назвать)
    // product fields
    ["complaints", "show_name 2", ""],
    ["complaintsResult", "show_name 2", ""],
    ["complaintsValue", "show_name 2", ""],

    ["highComplaints", "show_name 2", ""],
    ["highComplaintsResult", "show_name 2", ""],
    ["highComplaintsValue", "show_name 2", ""],

    ["doneComplaints", "show_name 2", ""],
    ["doneComplaintsResult", "show_name 2", ""],
    ["doneComplaintsValue", "show_name 2", ""],

    ["visitTasty", "show_name 2", ""],
    ["visitTastyResult", "show_name 2", ""],
    ["visitTastyValue", "show_name 2", ""],

    ["doneRoutin", "show_name 2", ""],
    ["doneRoutinResult", "show_name 2", ""],
    ["doneRoutinValue", "show_name 2", ""],

    ["inventory", "show_name 2", ""],
    ["inventoryResult", "show_name 2", ""],
    ["inventoryValue", "show_name 2", ""],

    ["debiting", "show_name 2", ""],
    ["debitingResult", "show_name 2", ""],
    ["debitingValue", "show_name 2", ""],

    ["nutrition", "show_name 2", ""],
    ["nutritionResult", "show_name 2", ""],
    ["nutritionValue", "show_name 2", ""],

    ["fat", "show_name 2", ""],
    ["fatResult", "show_name 2", ""],
    ["fatValue", "show_name 2", ""],

    ["consumables", "show_name 2", ""],
    ["consumablesResult", "show_name 2", ""],
    ["consumablesValue", "show_name 2", ""],

    ["remains", "show_name 2", ""],
    ["remainsResult", "show_name 2", ""],
    ["remainsValue", "show_name 2", ""],

    ["gaveTook", "show_name 2", ""],
    ["gaveTookResult", "show_name 2", ""],
    ["gaveTookValue", "show_name 2", ""],

    ["APRost", "show_name 2", ""],
    ["APRostResult", "show_name 2", ""],
    ["APRostValue", "show_name 2", ""],

    ["fullness", "show_name 2", ""],
    ["fullnessResult", "show_name 2", ""],
    ["fullnessValue", "show_name 2", ""],

    ["fatMeasurement", "show_name 2", ""],
    ["fatMeasurementResult", "show_name 2", ""],
    ["fatMeasurementValue", "show_name 2", ""],

    ["fatRange", "show_name 2", ""],
    ["fatRangeResult", "show_name 2", ""],
    ["fatRangeValue", "show_name 2", ""],
    ["yesProduct", "show_name 2", ""],
    // place fields
    ["onlineDelivery", "show_name 2", ""],
    ["onlineIndexCC", "show_name 2", ""],
    ["onlineIndexKiosk", "show_name 2", ""],
    ["noComplaints", "show_name 2", ""],
    ["limitPM", "show_name 2", ""],
    ["limitChemistry", "show_name 2", ""],
    ["doneAPPost", "show_name 2", ""],
    ["countDeviation", "show_name 2", ""],
    ["donePlaceClear", "show_name 2", ""],
    ["donePlaceCorrect", "show_name 2", ""],
    ["doneRoutine", "show_name 2", ""],
    ["countDoneTest", "show_name 2", ""],

    ["onlineDeliveryValue", "show_name 2", ""],
    ["onlineIndexCCValue", "show_name 2", ""],
    ["onlineIndexKioskValue", "show_name 2", ""],
    ["noComplaintsValue", "show_name 2", ""],
    ["limitPMValue", "show_name 2", ""],
    ["limitChemistryValue", "show_name 2", ""],
    ["doneAPPostValue", "show_name 2", ""],
    ["countDeviationValue", "show_name 2", ""],
    ["donePlaceClearValue", "show_name 2", ""],
    ["donePlaceCorrectValue", "show_name 2", ""],
    ["doneRoutineValue", "show_name 2", ""],
    ["countDoneTestValue", "show_name 2", ""],

    // Place Result поля
    ["onlineDeliveryResult", "show_name 2", ""],
    ["onlineIndexCCResult", "show_name 2", ""],
    ["onlineIndexKioskResult", "show_name 2", ""],
    ["noComplaintsResult", "show_name 2", ""],
    ["limitPMResult", "show_name 2", ""],
    ["limitChemistryResult", "show_name 2", ""],
    ["doneAPPostResult", "show_name 2", ""],
    ["countDeviationResult", "show_name 2", ""],
    ["donePlaceClearResult", "show_name 2", ""],
    ["donePlaceCorrectResult", "show_name 2", ""],
    ["doneRoutineResult", "show_name 2", ""],
    ["countDoneTestResult", "show_name 2", ""],
    ["yesPlace", "show_name 2", ""],
    // dataUsers
    ["dataProduct", "show_name 2", ""],
    ["dataPlace", "show_name 2", ""],
    ["dataSeniuor", "show_name 2", ""],
    ["ProductListPremium", "show_name 2", ""],
    ["PlaceListPremium", "show_name 2", ""],
  ];
  const [fields, setFields] = useState(DefaultFields);

  const Create = Post;
  const Update = Patch;

  async function loadRepost() {
    if (!startDate || !endDate) {
      setModalMessage(<p style={{ color: "red" }}>Есть не заполенные даты!</p>);
      setWorkSpinner(false);
      return;
    }
    const rep = await GetByDates(token, startDate, endDate);
    console.log(rep, "что выгружается");
    if (rep.length === 0) {
      setModalMessage(<p>Ничего нет, заполняйте</p>);
    }
    if (rep.length === 1) {
      let fields = DefaultFields;

      for (let field of fields) {
        for (let repField of rep[0].fields) {
          if (field[0] == repField[0]) {
            field[2] = repField[2];
            if (parseFloat(field[2]) || parseFloat(field[2]) === 0) {
              field[2] = parseFloat(field[2]);
            }
            break;
          }
        }
      }

      const legacyOsat = rep[0].fields.find((f) => f[0] === "resultOSAT");
      const hiField = fields.find((f) => f[0] === "resultHI");
      if (legacyOsat && hiField && !hiField[2] && hiField[2] !== 0) {
        hiField[2] = legacyOsat[2];
        if (parseFloat(hiField[2]) || parseFloat(hiField[2]) === 0) {
          hiField[2] = parseFloat(hiField[2]);
        }
      }

      setHaveReport(true);
      setReport(rep[0]);
      // setFields(rep[0].fields);
      setFields(fields);
      setModalMessage(<p style={{ color: "green" }}>Выгружено!</p>);
    }
    setWorkSpinner(false);
  }

  async function download() {
    const response = await Donwload(token, startDate, endDate);
    if (!startDate || !endDate) {
      setWorkSpinner(false);
      setModalMessage(<p style={{ color: "red" }}>Есть не заполенные даты!</p>);
      return;
    }
    // setWorkSpinner(true)
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Создание URL для blob
    const url = window.URL.createObjectURL(blob);

    // Создание временной ссылки для скачивания
    const link = document.createElement("a");
    link.href = url;

    // Получение имени файла из headers
    const contentDisposition = response.headers["content-disposition"];
    let filename = `motivation_mng_${startDate}_${endDate}.xlsx`;

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
      if (filenameMatch?.[1]) {
        filename = filenameMatch[1].trim();
      }
    }

    link.download = filename;

    // Автоматическое скачивание
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Очистка URL
    window.URL.revokeObjectURL(url);
    setModalMessage(<p style={{ color: "green" }}>Отчет скачен!</p>);
    setWorkSpinner(false);
  }

  async function saveReport() {
    if (!startDate || !endDate) {
      setWorkSpinner(false);
      setModalMessage(<p style={{ color: "red" }}>Есть не заполенные даты!</p>);
      return;
    }

    if (haveReport) {
      const data = await Update(token, report.id, {
        fields: fields,
      });
      console.log(data);
      if (data.detail) {
        setWorkSpinner(false);
        setModalMessage(<p style={{ color: "red" }}>{data.detail}</p>);
        return;
      }
      setReport(data);
      setModalMessage(<p style={{ color: "green" }}>Отчет обновлен!</p>);
    } else {
      const data = await Create(token, {
        report_id: reportId,
        start_date: startDate,
        end_date: endDate,
        fields: fields,
      });
      if (data.detail) {
        console.log(data.detail);
        setModalMessage(<p style={{ color: "red" }}>{data.detail}</p>);

        return;
      }
      setReport(data);
      setHaveReport(true);
      setModalMessage(<p style={{ color: "green" }}>Отчет создан!</p>);
    }
    setWorkSpinner(false);
  }

  function returnValue(code) {
    for (let field of fields) {
      if (field[0] === code) {
        if (field[2] || field[2] === 0) {
          return field[2];
        }
        return;
      }
    }
  }

  function updateValue(code, value) {
    if (!value) {
      value = 0;
    }
    for (let field in fields) {
      if (fields[field][0] === code) {
        updateFieldValue(field, value);
        return;
      }
    }
  }

  const updateFieldValue = (rowIndex, newValue) => {
    setFields((prevFields) =>
      prevFields.map((row, i) =>
        i === parseInt(rowIndex)
          ? row.map((cell, j) => (j === 2 ? newValue : cell))
          : [...row],
      ),
    );
  };

  const YesNoSelect = (nameField) => {
    return (
      <select
        className="form-control"
        value={returnValue(nameField)}
        onChange={(e) => updateValue(nameField, parseInt(e.target.value))}
      >
        <option value="">Не выбрано</option>
        <option value="1">да</option>
        <option value="0">нет</option>
      </select>
    );
  };

  const Inputfield = (nameField) => {
    return (
      <td>
        <input
          type="number"
          className="form-control"
          value={returnValue(nameField)}
          onChange={(e) => {
            updateValue(nameField, parseFloat(e.target.value));
          }}
        />
      </td>
    );
  };

  const NameFieldsProduct = [
    "complaintsValue",
    "highComplaintsValue",
    "doneComplaintsValue",
    "visitTastyValue",
    "doneRoutinValue",
    "inventoryValue",
    "debitingValue",
    "nutritionValue",
    "fatValue",
    "consumablesValue",
    "remainsValue",
    "gaveTookValue",
    "APRostValue",
    "fullnessValue",
    "fatMeasurementValue",
    "fatRangeValue",
  ];

  const NameFieldsPlace = [
    "onlineDeliveryValue",
    "onlineIndexCCValue",
    "onlineIndexKioskValue",
    "noComplaintsValue",
    "limitPMValue",
    "limitChemistryValue",
    "doneAPPostValue",
    "countDeviationValue",
    "donePlaceClearValue",
    "donePlaceCorrectValue",
    "doneRoutineValue",
    "countDoneTestValue",
  ];

  function calculateHIPremium(hi) {
    if (hi === undefined || hi === null || hi === "") {
      return 0;
    }
    if (hi < 40) {
      return -5000;
    }
    if (hi < 70) {
      return 0;
    }
    return 3000;
  }

  useEffect(() => {
    const value = returnValue("resultHI");
    updateValue("premiumHI", calculateHIPremium(value));
  }, [returnValue("resultHI")]);

  useEffect(() => {
    const value = returnValue("resultPOST");
    if (value === 1) {
      updateValue("premiumPOST", 0);
    } else {
      updateValue("premiumPOST", -5000);
    }
  }, [returnValue("resultPOST")]);

  useEffect(() => {
    const value = returnValue("resultPOSTMOSCOW");
    if (value === 1) {
      updateValue("premiumPOSTMOSCOW", 7000);
    } else if (value === 2) {
      updateValue("premiumPOSTMOSCOW", 5000);
    } else if (value === 3) {
      updateValue("premiumPOSTMOSCOW", 0);
    } else if (value === 4) {
      updateValue("premiumPOSTMOSCOW", -5000);
    } else if (value === 5) {
      updateValue("premiumPOSTMOSCOW", -7000);
    } else {
      updateValue("resultPOSTMOSCOW", 0);
    }
  }, [returnValue("resultPOSTMOSCOW")]);

  useEffect(() => {
    const value = returnValue("resultTMT");
    if (value <= 90) {
      updateValue("premiumTMT", 0);
    } else {
      updateValue("premiumTMT", -5000);
    }
  }, [returnValue("resultTMT")]);

  useEffect(() => {
    const value = returnValue("resultTO");
    if (value >= 16000000) {
      updateValue("premiumTO", 5000);
    } else if (value >= 13000000) {
      updateValue("premiumTO", 3000);
    } else {
      updateValue("premiumTO", 0);
    }
  }, [returnValue("resultTO")]);

  useEffect(() => {
    setReport({});
    setHaveReport(false);
    setFields(DefaultFields);
  }, [startDate, endDate]);

  useEffect(
    () => {
      console.log(123);
      let estimation = 0;
      let yes = 0;
      // complaints
      if (returnValue("complaintsValue") < 7) {
        updateValue("complaintsResult", 1);
        yes += 1;
      } else {
        updateValue("complaintsResult", 0);
      }

      // highComplaints
      if (returnValue("highComplaintsValue") === 0) {
        updateValue("highComplaintsResult", 1);
        yes += 1;
      } else {
        updateValue("highComplaintsResult", 0);
      }

      // doneComplaints
      if (returnValue("doneComplaintsValue") > 80) {
        updateValue("doneComplaintsResult", 1);
        yes += 1;
      } else {
        updateValue("doneComplaintsResult", 0);
      }

      // visitTasty
      if (returnValue("visitTastyValue") > 90) {
        updateValue("visitTastyResult", 1);
        yes += 1;
      } else {
        updateValue("visitTastyResult", 0);
      }

      // doneRoutin
      if (returnValue("doneRoutinValue") > 90) {
        updateValue("doneRoutinResult", 1);
        yes += 1;
      } else {
        updateValue("doneRoutinResult", 0);
      }

      // inventory
      if (returnValue("inventoryValue") < 0.2) {
        updateValue("inventoryResult", 1);
        yes += 1;
      } else {
        updateValue("inventoryResult", 0);
      }

      // debiting
      if (returnValue("debitingValue") === 1) {
        updateValue("debitingResult", 1);
        yes += 1;
      } else {
        updateValue("debitingResult", 0);
      }

      // nutrition
      if (returnValue("nutritionValue") === 1) {
        updateValue("nutritionResult", 1);
        yes += 1;
      } else {
        updateValue("nutritionResult", 0);
      }

      // fat
      if (returnValue("fatValue") === 1) {
        updateValue("fatResult", 1);
        yes += 1;
      } else {
        updateValue("fatResult", 0);
      }

      // consumables
      if (returnValue("consumablesValue") === 1) {
        updateValue("consumablesResult", 1);
        yes += 1;
      } else {
        updateValue("consumablesResult", 0);
      }

      // remains
      if (returnValue("remainsValue") === 1) {
        updateValue("remainsResult", 1);
        yes += 1;
      } else {
        updateValue("remainsResult", 0);
      }

      // gaveTook
      if (returnValue("gaveTookValue") < 5) {
        updateValue("gaveTookResult", 1);
        yes += 1;
      } else {
        updateValue("gaveTookResult", 0);
      }

      // APRost
      if (returnValue("APRostValue") > 80) {
        updateValue("APRostResult", 1);
        yes += 1;
      } else {
        updateValue("APRostResult", 0);
      }

      // fullness
      if (returnValue("fullnessValue") > 98) {
        updateValue("fullnessResult", 1);
        yes += 1;
      } else {
        updateValue("fullnessResult", 0);
      }

      // fatMeasurement
      if (returnValue("fatMeasurementValue") === 100) {
        updateValue("fatMeasurementResult", 1);
        yes += 1;
      } else {
        updateValue("fatMeasurementResult", 0);
      }

      // fatRange
      if (returnValue("fatRangeValue") === 100) {
        updateValue("fatRangeResult", 1);
        yes += 1;
      } else {
        updateValue("fatRangeResult", 0);
      }
      updateValue("yesProduct", yes);
      // for (let field in NameFieldsProduct) {
      //   let name = NameFieldsProduct[field];
      //   if (returnValue(name) === 1) {
      //     yes += 1;
      //   }
      // }
      estimation = (yes / NameFieldsProduct.length) * 100;
      // updateValue('yesProduct', estimation)
      // console.log(yes, NameFieldsProduct.length, estimation);
      if (estimation === 100) {
        updateValue("ProductListPremium", 20000);
      } else if (estimation >= 80) {
        updateValue("ProductListPremium", 10000);
      } else if (estimation >= 65) {
        updateValue("ProductListPremium", 5000);
      } else {
        updateValue("ProductListPremium", 0);
      }
    },
    NameFieldsProduct.map((field) => returnValue(field)),
    // NameFieldsProduct.map((field) => returnValue(field)),
  );

  useEffect(
    () => {
      console.log("place");
      let estimation = 0;
      let yes = 0;

      // onlineDelivery
      if (returnValue("onlineDeliveryValue") > 99) {
        updateValue("onlineDeliveryResult", 1);
        yes += 1;
      } else {
        updateValue("onlineDeliveryResult", 0);
      }

      // onlineIndexCC
      if (returnValue("onlineIndexCCValue") > 99) {
        updateValue("onlineIndexCCResult", 1);
        yes += 1;
      } else {
        updateValue("onlineIndexCCResult", 0);
      }

      // onlineIndexKiosk
      if (returnValue("onlineIndexKioskValue") > 98) {
        updateValue("onlineIndexKioskResult", 1);
        yes += 1;
      } else {
        updateValue("onlineIndexKioskResult", 0);
      }

      // noComplaints
      if (returnValue("noComplaintsValue") === 0) {
        updateValue("noComplaintsResult", 1);
        yes += 1;
      } else {
        updateValue("noComplaintsResult", 0);
      }

      // limitPM
      if (returnValue("limitPMValue") === 1) {
        updateValue("limitPMResult", 1);
        yes += 1;
      } else {
        updateValue("limitPMResult", 0);
      }

      // limitChemistry
      if (returnValue("limitChemistryValue") === 1) {
        updateValue("limitChemistryResult", 1);
        yes += 1;
      } else {
        updateValue("limitChemistryResult", 0);
      }

      // doneAPPost
      if (returnValue("doneAPPostValue") > 80) {
        updateValue("doneAPPostResult", 1);
        yes += 1;
      } else {
        updateValue("doneAPPostResult", 0);
      }

      // countDeviation
      if (returnValue("countDeviationValue") <= 4) {
        updateValue("countDeviationResult", 1);
        yes += 1;
      } else {
        updateValue("countDeviationResult", 0);
      }

      // donePlaceClear
      if (returnValue("donePlaceClearValue") > 80) {
        updateValue("donePlaceClearResult", 1);
        yes += 1;
      } else {
        updateValue("donePlaceClearResult", 0);
      }

      // donePlaceCorrect
      if (returnValue("donePlaceCorrectValue") > 95) {
        updateValue("donePlaceCorrectResult", 1);
        yes += 1;
      } else {
        updateValue("donePlaceCorrectResult", 0);
      }

      // doneRoutine
      if (returnValue("doneRoutineValue") > 90) {
        updateValue("doneRoutineResult", 1);
        yes += 1;
      } else {
        updateValue("doneRoutineResult", 0);
      }

      // countDoneTest
      if (returnValue("countDoneTestValue") === 100) {
        updateValue("countDoneTestResult", 1);
        yes += 1;
      } else {
        updateValue("countDoneTestResult", 0);
      }

      updateValue("yesPlace", yes);

      estimation = (yes / NameFieldsPlace.length) * 100;

      if (estimation === 100) {
        updateValue("PlaceListPremium", 10000);
      } else if (estimation >= 80) {
        updateValue("PlaceListPremium", 7000);
      } else if (estimation >= 65) {
        updateValue("PlaceListPremium", 4000);
      } else {
        updateValue("PlaceListPremium", 0);
      }
    },
    NameFieldsPlace.map((field) => returnValue(field)),
  );

  useEffect(() => {
    let totalJuniour =
      juniourMNGPremium +
      (returnValue("premiumHI") || 0) +
      (returnValue("premiumPOST") || 0) +
      (returnValue("premiumPOSTMOSCOW") || 0) +
      (returnValue("premiumTO") || 0);
    updateValue("premiumJuniourNMG", totalJuniour);

    let totalSeniour =
      seniourMNGPremium +
      (returnValue("premiumHI") || 0) +
      (returnValue("premiumPOST") || 0) +
      (returnValue("premiumPOSTMOSCOW") || 0) +
      (returnValue("premiumTMT") || 0) +
      (returnValue("premiumTO") || 0);
    updateValue("premiumSeniorMNG", totalSeniour);

    let totalProduct =
      MNGPremium +
      (returnValue("premiumHI") || 0) +
      (returnValue("premiumPOST") || 0) +
      (returnValue("premiumPOSTMOSCOW") || 0) +
      (returnValue("ProductListPremium") || 0) +
      (returnValue("premiumTO") || 0);
    updateValue("premiumProductMNG", totalProduct);
    let totalPlace =
      MNGPremium +
      (returnValue("premiumHI") || 0) +
      (returnValue("premiumPOST") || 0) +
      (returnValue("premiumPOSTMOSCOW") || 0) +
      (returnValue("PlaceListPremium") || 0) +
      (returnValue("premiumTO") || 0);
    updateValue("premiumPlaceMNG", totalPlace);

    // let totalSeniour = sumFields(fields, [1, 3, 5, 7, 13]);
    // updateFieldValue(17, seniourMNGPremium + totalSeniour);
  }, [
    returnValue("premiumHI"),
    returnValue("premiumPOST"),
    returnValue("premiumPOSTMOSCOW"),
    returnValue("premiumTO"),
    returnValue("premiumTMT"),
    returnValue("PlaceListPremium"),
    returnValue("ProductListPremium"),
    // returnValue("resultPOST"),
  ]);

  function renderTable() {
    return (
      <table className="table table-bordered text-center">
        <thead>
          <tr>
            <th>Поле</th>
            <th>Цель</th>
            <th>Результат</th>
            <th>Премия</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1. HI</td>
            <td>&gt;=70</td>
            {Inputfield("resultHI")}
            <td>{returnValue("premiumHI")}</td>
          </tr>
          <tr>
            <td>2. РОСТ Самоаудит</td>
            <td> да</td>
            <td>{YesNoSelect("resultPOST")}</td>
            <td>{returnValue("premiumPOST")}</td>
          </tr>
          <tr>
            <td>3. РОСТ Москва</td>
            <td> A, B</td>
            <td>
              <select
                className="form-control"
                value={returnValue("resultPOSTMOSCOW")}
                onChange={(e) =>
                  updateValue("resultPOSTMOSCOW", parseInt(e.target.value))
                }
              >
                <option value="">Не выбрано</option>
                <option value="1">A</option>
                <option value="2">B</option>
                <option value="3">C</option>
                <option value="4">D</option>
                <option value="5">F</option>
              </select>
            </td>
            <td>{returnValue("premiumPOSTMOSCOW")}</td>
          </tr>

          <tr>
            <td>4. TMT</td>
            <td>&lt; 90</td>
            {Inputfield("resultTMT")}
            <td>{returnValue("premiumTMT")}</td>
          </tr>
          <tr>
            <td>5. TO</td>
            <td>Как можно больше)</td>
            {Inputfield("resultTO")}
            <td>{returnValue("premiumTO")}</td>
          </tr>
        </tbody>
      </table>
    );
  }

  function renderTable2() {
    return (
      <table className="table table-bordered text-center">
        <thead>
          <tr>
            <th>Должность</th>
            <th>Базовая премия</th>
            <th>KPI</th>
            <th>Цель</th>
            <th>Результат</th>
            <th>Премия</th>
            <th>Итого</th>
          </tr>
        </thead>
        <tbody>
          {/* for junior */}
          <tr>
            <td rowSpan={3} className="align-middle">
              М МС
            </td>
            <td rowSpan={3} className="align-middle">
              {juniourMNGPremium}
            </td>
            <td>1. HI</td>
            <td>&gt;=70</td>
            <td>{returnValue("resultHI")}</td>
            <td>{returnValue("premiumHI")}</td>
            <td rowSpan={3} className="align-middle">
              {returnValue("premiumJuniourNMG")}
            </td>
          </tr>
          <tr>
            <td>2. Рост самоаудит</td>
            <td>да</td>
            <td>{returnValue("resultPOST")}</td>
            <td>{returnValue("premiumPOST")}</td>
          </tr>
          <tr>
            <td>3. Рост Москва</td>
            <td>A, B</td>
            <td>{returnValue("resultPOSTMOSCOW")}</td>
            <td>{returnValue("premiumPOSTMOSCOW")}</td>
          </tr>
          {/* for product and place */}
          <tr>
            <td rowSpan={3} className="align-middle">
              Product / Place
            </td>
            <td rowSpan={3} className="align-middle">
              {MNGPremium}
            </td>
            <td>1. HI</td>
            <td>&gt;=70</td>
            <td>{returnValue("resultHI")}</td>
            <td>{returnValue("premiumHI")}</td>
            <td rowSpan={3} className="align-middle">
              {returnValue("premiumProductMNG")} /{" "}
              {returnValue("premiumPlaceMNG")}
            </td>
          </tr>
          <tr>
            <td>2. Рост самоаудит</td>
            <td>да</td>
            <td>{returnValue("resultPOST")}</td>
            <td>{returnValue("premiumPOST")}</td>
          </tr>
          <tr>
            <td>3. Рост Москва</td>
            <td>A, B</td>
            <td>{returnValue("resultPOSTMOSCOW")}</td>
            <td>{returnValue("premiumPOSTMOSCOW")}</td>
          </tr>
          {/* for seniour */}
          <tr>
            <td rowSpan={4} className="align-middle">
              Ст МС
            </td>
            <td rowSpan={4} className="align-middle">
              {seniourMNGPremium}
            </td>
            <td>1. HI</td>
            <td>&gt;=70</td>
            <td>{returnValue("resultHI")}</td>
            <td>{returnValue("premiumHI")}</td>
            <td rowSpan={4} className="align-middle">
              {returnValue("premiumSeniorMNG")}
            </td>
          </tr>
          <tr>
            <td>2. Рост самоаудит</td>
            <td>да</td>
            <td>{returnValue("resultPOST")}</td>
            <td>{returnValue("premiumPOST")}</td>
          </tr>
          <tr>
            <td>3. Рост Москва</td>
            <td>A, B</td>
            <td>{returnValue("resultPOSTMOSCOW")}</td>
            <td>{returnValue("premiumPOSTMOSCOW")}</td>
          </tr>
          <tr>
            <td>4. TMT</td>
            <td>&lt;= 90</td>
            <td>{returnValue("resultTMT")}</td>
            <td>{returnValue("premiumTMT")}</td>
          </tr>
        </tbody>
      </table>
    );
  }

  function renderProductTable() {
    return (
      <table className="table table-bordered text-center">
        <thead>
          <tr>
            <th colSpan={2}>KPI</th>
            <th>Цель</th>
            <th>Результат</th>
            <th>Итого</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td rowSpan={5} className="align-middle">
              Гостевой опыт
            </td>
            <td>Жалобы на продукт, на 10 000 ТА </td>
            <td> &lt; 7</td>
            {Inputfield("complaintsValue")}
            <td>{returnValue("complaintsResult")}</td>
          </tr>
          <tr>
            <td>Высоких жалоб на продукт</td>
            <td>0</td>
            {Inputfield("highComplaintsValue")}
            <td>{returnValue("highComplaintsResult")}</td>
          </tr>
          <tr>
            <td>% выполнения AP по жалобам </td>
            <td> &gt; 80%</td>
            {Inputfield("doneComplaintsValue")}
            <td>{returnValue("doneComplaintsResult")}</td>
          </tr>
          <tr>
            <td>Визиту Taste (RGM, AC)</td>
            <td> &gt; 90%</td>
            {Inputfield("visitTastyValue")}
            <td>{returnValue("visitTastyResult")}</td>
          </tr>
          <tr>
            <td>% выполнения рутины PRODUCT </td>
            <td> &gt; 90%</td>
            {Inputfield("doneRoutinValue")}
            <td>{returnValue("doneRoutinResult")}</td>
          </tr>
          <tr>
            <td rowSpan={7} className="align-middle">
              COS
            </td>
            <td>% инвентаризации</td>
            <td> &lt; 0,2%</td>
            {Inputfield("inventoryValue")}
            <td>{returnValue("inventoryResult")}</td>
          </tr>
          <tr>
            <td>В% Cписания</td>
            <td>target</td>
            <td>{YesNoSelect("debitingValue")}</td>
            <td>{returnValue("debitingResult")}</td>
          </tr>
          <tr>
            <td>% Питания </td>
            <td>target</td>
            <td>{YesNoSelect("nutritionValue")}</td>
            <td>{returnValue("nutritionResult")}</td>
          </tr>
          <tr>
            <td>% Жира</td>
            <td>target</td>
            <td>{YesNoSelect("fatValue")}</td>
            <td>{returnValue("fatResult")}</td>
          </tr>
          <tr>
            <td>% Расходники в ИВЛ</td>
            <td>target</td>
            <td>{YesNoSelect("consumablesValue")}</td>
            <td>{returnValue("consumablesResult")}</td>
          </tr>
          <tr>
            <td>Остатки не выше цели</td>
            <td>target</td>
            <td>{YesNoSelect("remainsValue")}</td>
            <td>{returnValue("remainsResult")}</td>
          </tr>
          <tr>
            <td>%ВП в ресторан (отдал+взял)</td>
            <td> &lt; 5</td>
            {Inputfield("gaveTookValue")}
            <td>{returnValue("gaveTookResult")}</td>
          </tr>
          <tr>
            <td rowSpan={4} className="align-middle">
              РОСТ
            </td>
            <td>% выполнения AP по РОСТ</td>
            <td> &gt; 80%</td>
            {Inputfield("APRostValue")}
            <td>{returnValue("APRostResult")}</td>
          </tr>
          <tr>
            <td>Заполненость МД &gt; 95%</td>
            <td> &gt; 98%</td>
            {Inputfield("fullnessValue")}
            <td>{returnValue("fullnessResult")}</td>
          </tr>
          <tr>
            <td>Замер жира через BT (анализатор исправен) </td>
            <td> 100%</td>
            {Inputfield("fatMeasurementValue")}
            <td>{returnValue("fatMeasurementResult")}</td>
          </tr>
          <tr>
            <td>Жир более 20% - &lt; 5%, жир более 25 - 0% </td>
            <td> 100%</td>
            {Inputfield("fatRangeValue")}
            <td>{returnValue("fatRangeResult")}</td>
          </tr>
          <tr>
            <td>Премия</td>
            <td colSpan={3}>{returnValue("premiumProductMNG")}</td>
            <td>{returnValue("yesProduct")}</td>
          </tr>
        </tbody>
      </table>
    );
  }

  function renderPlaceTable() {
    return (
      <table className="table table-bordered text-center">
        <thead>
          <tr>
            <th colSpan={2}>KPI</th>
            <th>Цель</th>
            <th>Результат</th>
            <th>Итого</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td rowSpan={4} className="align-middle">
              Гостевой опыт
            </td>
            <td>Online Index Delivery</td>
            <td>&gt; 99%</td>
            {Inputfield("onlineDeliveryValue")}
            <td>{returnValue("onlineDeliveryResult")}</td>
          </tr>
          <tr>
            <td>Online Index C&C</td>
            <td>&gt; 99%</td>
            {Inputfield("onlineIndexCCValue")}
            <td>{returnValue("onlineIndexCCResult")}</td>
          </tr>
          <tr>
            <td>Online Index киоск</td>
            <td>&gt; 98%</td>
            {Inputfield("onlineIndexKioskValue")}
            <td>{returnValue("onlineIndexKioskResult")}</td>
          </tr>
          <tr>
            <td>Отсутствуют жалобы по чистоте и исправному состоянию</td>
            <td>0</td>
            {Inputfield("noComplaintsValue")}
            <td>{returnValue("noComplaintsResult")}</td>
          </tr>

          <tr>
            <td rowSpan={2} className="align-middle">
              Semis
            </td>
            <td>Лимит РМ</td>
            <td>target</td>
            <td>{YesNoSelect("limitPMValue")}</td>
            <td>{returnValue("limitPMResult")}</td>
          </tr>
          <tr>
            <td>Лимит химия</td>
            <td>target</td>
            <td>{YesNoSelect("limitChemistryValue")}</td>
            <td>{returnValue("limitChemistryResult")}</td>
          </tr>

          <tr>
            <td rowSpan={6} className="align-middle">
              РОСТ
            </td>
            <td>% выполнения AP по РОСТ</td>
            <td>&gt; 80%</td>
            {Inputfield("doneAPPostValue")}
            <td>{returnValue("doneAPPostResult")}</td>
          </tr>
          <tr>
            <td>Количество отклонений РОСТ МСК по тех состоянию + чистота</td>
            <td>&lt;=4</td>
            {Inputfield("countDeviationValue")}
            <td>{returnValue("countDeviationResult")}</td>
          </tr>
          <tr>
            <td>% выполнения чек-листа PLACE чистота</td>
            <td>&gt; 80%</td>
            {Inputfield("donePlaceClearValue")}
            <td>{returnValue("donePlaceClearResult")}</td>
          </tr>
          <tr>
            <td>% выполнения чек-листа PLACE исправное состояние</td>
            <td>&gt; 95%</td>
            {Inputfield("donePlaceCorrectValue")}
            <td>{returnValue("donePlaceCorrectResult")}</td>
          </tr>
          <tr>
            <td>% выполнения рутины Place</td>
            <td>&gt; 90%</td>
            {Inputfield("doneRoutineValue")}
            <td>{returnValue("doneRoutineResult")}</td>
          </tr>
          <tr>
            <td>% сотрудников, прошедших тест по химии</td>
            <td>100%</td>
            {Inputfield("countDoneTestValue")}
            <td>{returnValue("countDoneTestResult")}</td>
          </tr>

          <tr>
            <td colSpan={3}>Премия</td>

            <td>{returnValue("premiumPlaceMNG")}</td>
            <td>{returnValue("yesPlace")}</td>
          </tr>
        </tbody>
      </table>
    );
  }

  function renderTableDataUsers() {
    return (
      <table className="table table-bordered text-center">
        <thead>
          <tr>
            <th>Должность</th>
            <th>Данные</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Product</td>
            <td>
              <textarea
                type="text"
                className="form-control"
                value={returnValue("dataProduct")}
                onChange={(e) => updateValue("dataProduct", e.target.value)}
              />
            </td>
          </tr>
          <tr>
            <td>Place</td>
            <td>
              <textarea
                type="text"
                className="form-control"
                value={returnValue("dataPlace")}
                onChange={(e) => updateValue("dataPlace", e.target.value)}
              />
            </td>
          </tr>
          <tr>
            <td>Старшие МНГ</td>
            <td>
              <textarea
                type="text"
                className="form-control"
                value={returnValue("dataSeniuor")}
                onChange={(e) => updateValue("dataSeniuor", e.target.value)}
              />
            </td>
          </tr>
        </tbody>
      </table>
    );
  }

  // function addRow() {
  //   console.log("addrow", testDataTable);
  //   setTestDataTable({
  //     ...testDataTable,
  //     body: [...testDataTable.body, [{ text: "Null" }]],
  //   });
  // }

  // function editField(id) {
  //   console.log(id);
  // }

  // function renderTestTable() {
  //   if (
  //     testDataTable["header"].length == 0 &&
  //     testDataTable["body"].length == 0
  //   ) {
  //     return (
  //       <table className="table table-bordered text-center">
  //         <thead></thead>
  //         <tbody>
  //           <tr>
  //             <td>
  //               <button onClick={addRow}>добавить строку</button>
  //             </td>
  //           </tr>
  //         </tbody>
  //       </table>
  //     );
  //   } else {
  //     return (
  //       <table className="table table-bordered text-center">
  //         <thead></thead>
  //         <tbody>
  //           {testDataTable.body.map((row, key) => (
  //             // console.log(row, )
  //             <tr>
  //               {row.map((value, id) => (
  //                 <td onClick={() => editField(id)}>{value.text}</td>
  //               ))}
  //             </tr>
  //           ))}
  //           <tr>
  //             <td>
  //               <button onClick={addRow}>добавить строку</button>
  //             </td>
  //           </tr>
  //         </tbody>
  //       </table>
  //     );
  //   }
  // }

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12" style={{ marginTop: "1%" }}>
          <h1 className="text-center">Отчет по Мотивации МНГ</h1>
        </div>
        <div className="col-md-5 row" style={{ marginTop: "3%" }}>
          <label htmlFor="" className="col-md-5 col-form-label">
            Начальная дата:
          </label>
          <div className="col-md-7">
            <input
              className="form-control"
              type="date"
              name=""
              id=""
              onChange={(e) => setStartDate(e.target.value)}
              value={startDate}
            />
          </div>
        </div>

        <div className="col-md-5 row" style={{ marginTop: "3%" }}>
          <label htmlFor="" className="col-md-5 col-form-label">
            Конечная дата:
          </label>
          <div className="col-md-7">
            <input
              className="form-control"
              type="date"
              name=""
              id=""
              onChange={(e) => setEndDate(e.target.value)}
              value={endDate}
            />
          </div>
        </div>

        <div className="col-md-2" style={{ marginTop: "3%" }}>
          <button
            className="btn"
            onClick={() => {
              setWorkSpinner(true);
              loadRepost();
            }}
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop"
          >
            Выгрузить
          </button>
          {/* <button onClick={downloadExcel}>xlsx</button> */}
        </div>
      </div>
      <div className="row" style={{ marginTop: "5%" }}>
        {renderTable()}
        {renderTable2()}
        <h3 className="text-center">Product</h3>
        {renderProductTable()}
        <h3 className="text-center">Place</h3>
        {renderPlaceTable()}
        <h3 className="text-center">Данные о сотрудниках</h3>
        {renderTableDataUsers()}

        {/* <button onClick={addRow}>addRow</button> */}
        {/* {renderTestTable()} */}
      </div>
      <div className="row">
        <div className="col-md-2">
          <button
            className="btn"
            onClick={() => {
              setWorkSpinner(true);
              saveReport();
            }}
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop"
          >
            Сохранить
          </button>
        </div>
        <div className="col-md-2">
          {accessLevel > 12 && (
            <button
              className="btn"
              onClick={() => {
                setWorkSpinner(true); // Первое действие
                download(); // Второе действие
              }}
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop"
            >
              Скачать
            </button>
          )}
        </div>

        <div className="row">
          <div className="col-md-6">
            {report["creater_name"] && (
              <>
                Создано{" "}
                {`${report["creater_name"]} ${report["creater_surname"]}`} в{" "}
                {report["created"]}
              </>
            )}
          </div>
          <div className="col-md-6">
            {report["updater_name"] && (
              <>
                Последнее обновление{" "}
                {`${report["updater_name"]} ${report["updater_surname"]}`} в{" "}
                {report["updated"]}
              </>
            )}
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="staticBackdrop"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header justify-content-center">
              <h5 className="modal-title text-center" id="staticBackdropLabel">
                Информация
              </h5>
            </div>
            <div className="modal-body text-center">
              {workSpinner && (
                <div className="spinner-border text-danger" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}

              {modalMessage}
              {/* <p className="text-center">{message[0]}</p>
                    <p className="text-center">{message[1]}</p> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MotivationMNG;

function createArrayFieldsForUseFetch(fields, nums) {
  let ar = [];
  for (let index of nums) {
    ar.push(fields[index][2]);
  }
  return ar;
}

function sumFields(fields, nums) {
  let sum = 0;
  for (let index of nums) {
    sum += parseFloat(fields[index]?.[2] || 0);
  }
  return sum;
}
